import { useEffect, useState } from 'react';
import styled from 'styled-components';
import api from '../../../../Component/axios_Interceptor/api';
import url from '../../../../Component/server';
import ExpandableNotice from '../../../../Component/UI/ExpandableNotice';

export default function LiveChatNotices({ liveSeq }: { liveSeq: number }) {
  const [regular, setRegular] = useState('');
  useEffect(() => {
    setRegular('');
    let active = true, version = 0;
    const load = async () => {
      const request = ++version;
      try {
        const response = await api.get(url.Communication_url.get_live_notice, { params: { seq: liveSeq, type: 'rn' } });
        if (active && request === version && Array.isArray(response.data)) setRegular(response.data
          .filter(item => item?.type === 'rn' && typeof item.content === 'string').map(item => item.content.trim()).filter(Boolean).join('\n'));
      } catch { /* Keep the last confirmed notice during a temporary connection failure. */ }
    };
    const focus = () => { if (!document.hidden) void load(); };
    void load();
    window.addEventListener('focus', focus);
    const timer = window.setInterval(focus, 15000);
    return () => { active = false; window.clearInterval(timer); window.removeEventListener('focus', focus); };
  }, [liveSeq]);
  if (!regular) return null;
  return <Notices aria-label="라이브 채팅 공지사항">
    {regular && <aside role="note" aria-label="공지"><strong>공지</strong><ExpandableNotice content={regular} collapsedLines={2} /></aside>}
  </Notices>;
}

const Notices = styled.div`
  flex-shrink: 0; display: grid; gap: var(--space-2);
  aside { min-width: 0; padding: var(--space-3); border: 1px solid var(--color-border-default); border-radius: var(--radius-md); background: var(--color-bg-muted); }
  strong { display: block; margin-bottom: var(--space-1); color: var(--color-text-link); }
`;
